<template>
  <Wrapper>
    <figure class="slider__list">
      <img
        class="slider-img"
        src="../../../assets/images/pc-main-visual.png"
        alt=""
      />
    </figure>
    <main class="main">
      <FlowParticipation :lang="lang" :langPath="langPath"></FlowParticipation>
      <NoticeList
        :lang="lang"
        :langPath="langPath"
        v-if="showNotice"
      ></NoticeList>
      <EventList :lang="lang" :langPath="langPath"></EventList>
      <TokyoMarathonFoundation :langPath="langPath"></TokyoMarathonFoundation>
    </main>
  </Wrapper>
</template>

<script>
import Wrapper from "../../../components/pc/Wrapper";
import FlowParticipation from "../../../components/pc/top/FlowParticipation";
import EventList from "../../../components/pc/top/EventList";
import NoticeList from "../../../components/pc/top/NoticeList";
import TokyoMarathonFoundation from "../../../components/pc/top/TokyoMarathonFoundation";
export default {
  data() {
    return {
      showNotice: true,
    };
  },
  /**
   * TOP以外からの遷移に対応
   */
  mounted() {
    // NOTE NOTICEの時間指定があった時用
    // const currentDate = new Date();
    // if (currentDate < Date.parse("2021-03-18T09:55:00")) {
    //   this.showNotice = true;
    // }

    // router/index.jsでスクロールに0.4秒待つためsetTimeoutで処理を遅らせる
    setTimeout(() => {
      if (this.$route.query.from) {
        const element = document.getElementById("event-section");
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  },
  computed: {
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  components: {
    Wrapper,
    FlowParticipation,
    NoticeList,
    EventList,
    TokyoMarathonFoundation,
  },
  name: "Top",
};
</script>

<style scoped>
.slider__list {
  .slider-img {
    width: 100%;
  }
}
/*共通paddingを考慮*/
.main {
  margin: 35px auto 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/pc/top/Top.vue